import { render } from "./ScrollSelect2.vue?vue&type=template&id=a70b6b66"
import script from "./ScrollSelect2.vue?vue&type=script&lang=js"
export * from "./ScrollSelect2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__